import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import SideMenu from "../../components/SideMenu";
import "./SupportRequest.css";

export default function SupportRequest() {
  const { id } = useParams();
  const { user,dispatch } = useAuthContext();
  const navi = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [entries, setEntries] = useState([]);
  const [message, setMessage] = useState("");
  const [messageErr, setMessageErr] = useState("");
  const [selectedRequest, setSelectedRequest] = useState(null);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const supportRequestResponse = await axios.get(
        `${ApiConnectionString}/api/SupportRequest/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (supportRequestResponse.status == 200) {
        setSelectedRequest(supportRequestResponse.data);
      }

      const entriesResponse = await axios.get(
        `${ApiConnectionString}/api/SupportEntries/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (entriesResponse.status == 200) {
        setEntries(entriesResponse.data);
      } else {
        // Handle unexpected status codes if necessary
        console.error(`Unexpected status code: ${entriesResponse.status}`);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      // Handle the error appropriately
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Ensure loading state is set to false
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const hanldeSubmitEntry = async (e) => {
    setMessageErr("");
    e.preventDefault();
    let error = false;
    if (message.length > 3000) {
      setMessageErr("The Message cannot exceed 3000 characters.");
    }
    if (message.length != 0 && !error) {
      const createEntry = {
        supportRequestId: selectedRequest.id,
        context: message,
      };
      const entryResponse = await axios.post(
        `${ApiConnectionString}/api/SupportEntry`,
        createEntry,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (entryResponse.status == 200) {
        setMessage("");
        const newEntry = {
          id: entries.length + 1, // Just a simple way to generate unique IDs
          admin: false,
          username: user.username,
          created: new Date().toISOString(),
          context: message,
        };
        setEntries((prevEntries) => [...prevEntries, newEntry]);
      }
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div>
        <div className="container">
          <div className="row">
            <div className="col-3 side-menu-container">
              <SideMenu />
            </div>
            <div className="col bg-white srMargin my-2 p-0 ">
              <div className="blueBanner">
                <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
                  Support Request
                </p>
              </div>
              <div className="d-flex">
                <div className="m-4">
                  <p className="red-text mb-0">Id</p>
                  <p className="fw-bold">{selectedRequest.id}</p>
                </div>
                <div className="m-4">
                  <p className="red-text mb-0">Created</p>
                  <p className="fw-bold">
                    {selectedRequest.created.substring(0, 10)}
                  </p>
                </div>
                <div className="m-4">
                  <p className="red-text mb-0">Subject</p>
                  <p className="fw-bold">{selectedRequest.subject}</p>
                </div>
                <div className="m-4">
                  <p className="red-text mb-0">Active</p>
                  <p className="fw-bold">
                    {" "}
                    {selectedRequest.active ? "Yes" : "No"}
                  </p>
                </div>
              </div>
              <div className="">
                <div
                  className="bg-light p-3 border rounded"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  <ul className="list-unstyled">
                    {entries.map((entry) => (
                      <li
                        key={entry.id}
                        className="mb-3 p-3 border rounded bg-white"
                      >
                        <div className="d-flex">
                          <p className="red-text fw-bold">{entry.username}</p>
                          <p className="mx-2 text-muted">
                            {new Date(entry.created).toLocaleString()}
                          </p>
                        </div>
                        <p className="">{entry.context}</p>
                      </li>
                    ))}
                  </ul>
                </div>
                {selectedRequest.active ? (
                  <>
                    <div className="mt-3 mx-5">
                      <p className="blueText fw-bold">Message:</p>
                      <textarea
                        className="form-control"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      ></textarea>

                      <button
                        className="saveChanges-button mt-3"
                        onClick={hanldeSubmitEntry}
                      >
                        {" "}
                        Add Entry
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="alert alert-success mt-3">
                    Support Request has been resolved
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
